export const FINISH_HEIGHT = 120;
export const MIN_OPACITY = 0;
export const MAX_OPACITY = 0.9;
export const MAX_SEARCH_BG_NUM = 255;
export const MIN_SEARCH_BG_NUM = 244;
